import React, { useState } from "react";

const techLogos = [
  { src: require("../../assets/tanserflow.png"), alt: "TenserFlow" },
  { src: require("../../assets/payTorch.png"), alt: "Paytorch" },
  { src: require("../../assets/longChain.webp"), alt: "LangChain" },
  { src: require("../../assets/rails.png"), alt: "Rails" },
  { src: require("../../assets/next.png"), alt: "next" },
  { src: require("../../assets/reacticon.png"), alt: "React" },
  { src: require("../../assets/angular.png"), alt: "Angular" },
  { src: require("../../assets/nodejs.png"), alt: "Node.js" },
  { src: require("../../assets/android.png"), alt: "Swift" },
  { src: require("../../assets/amazon.png"), alt: "Android" },
  { src: require("../../assets/docker.png"), alt: "AWS" },
  { src: require("../../assets/python.png"), alt: "Docker" },
  { src: require("../../assets/graphql.png"), alt: "graphql" },
  { src: require("../../assets/django.png"), alt: "Python" },
  { src: require("../../assets/vuejs.png"), alt: "Kotlin" },
  { src: require("../../assets/Golang.png"), alt: "Golang" },
  { src: require("../../assets/shopify.png"), alt: "Shopify" }
];

const TechExpertise = () => {
  const [showAll, setShowAll] = useState(false);




  const displayedLogos = showAll ? techLogos : techLogos.slice(0, 6);

  return (
    <div className="max-w-6xl mx-auto text-center p-6 md:p-10 bg-white mt-10 font-primary md:mt-20 mb-20">
      <h2 className="text-xl font-bold mb-6 font-primary text-gray-900">Our Tech Expertise</h2>
      <div className="grid grid-cols-3 gap-6 pt-4 border-t border-gray-300">
        {displayedLogos.map((logo, index) => (
          <div key={index} className={`flex justify-center items-center p-4 border-b border-gray-300 ${index % 3 !== 2 ? 'border-r' : ''}`}>
            {logo.src ? (
              <img src={logo.src} alt={logo.alt} className="w-100 h-16 md:w-100 md:h-20" />
            ) : (
              <span className="text-gray-900 font-bold font-primary">{logo.alt}</span>
            )}
          </div>
        ))}
      </div>
      <button
        className="mt-8 px-6 py-2 text-lg md:text-base font-semibold  rounded-lg bg-white hover:bg-blue-600 hover:text-white transition-all duration-500 text-blue-600 border-2  font-primary border-blue-600"
        onClick={() => setShowAll(!showAll)}
      >
        {showAll ? "See Less" : "See All"}
      </button>
    </div>
  );
};

export default TechExpertise;